<div>
  <h1 class="header">Join our community of progressive activists for FREE</h1>

  <div class="issues">
    <div class="issue">
      <div class="icon">
        <img src="/assets/signup-icons/free-customize.svg" />
      </div>
      <div class="description">
        <h3>Customize your feed</h3>
        <p>Pick your favorite topics, hosts, shows, and canidates. All pushed in real time to all your devices with your
          favorite content. </p>
      </div>
    </div>

    <div class="issue">
      <div class="icon">
        <img src="/assets/signup-icons/free-keep-watching.svg" />
      </div>
      <div class="description">
        <h3>Keep watching</h3>
        <p>Playback tracking let’s you explore our expansive show library, yet still always pick back up wherever you
          left off. </p>
      </div>
    </div>
  </div>

  <div class="c2a">
    <h4>Sign up instantly for <strong>free</strong> from any account.</h4>

    <div class="sign-up-social">
      <a [href]="oauthUrlFor('google')">
        <img src="/assets/icons-2019/icon-google.svg" />
        <span>Google</span>
      </a>
      <a [href]="oauthUrlFor('twitter')">
        <img src="/assets/icons-2019/icon-twitter.svg" />
        <span>Twitter</span>
      </a>
      <a [href]="oauthUrlFor('facebook')">
        <img src="/assets/icons-2019/icon-facebook.svg" />
        <span>Facebook</span>
      </a>
      <a [href]="oauthUrlFor('youtube')">
        <img src="/assets/icons-2019/icon-youtube.svg" />
        <span>Youtube</span>
      </a>
    </div>
    <div class="signup-email">
      <a href="/signup">Or Sign up with your email</a>
    </div>
  </div>
</div>